module.exports = __webpack_public_path__ + "static/media/1.baf33955.mp3";